import { InjectionToken } from '@angular/core';

/** Parent host for the Breakdown tab (CODE_CLEANUP_SPEC Step 4). */
export const BREAKDOWN_HOST = new InjectionToken<any>('BREAKDOWN_HOST');
